// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".honor-tabs .v-tabs-bar{background:transparent!important;border-bottom:2px solid #212123}.honor-tabs .v-tabs-bar .v-slide-group__wrapper{margin-bottom:-2px}.honor-tabs .v-tabs-bar .v-tab{font-weight:400}", ""]);
// Exports
module.exports = exports;
